import { useMemo } from 'react';
import { GLPeriods } from 'src/services/useGLPeriodApi';
import { IBudgetPeriod } from 'src/types/BudgetPeriod';
export interface BudgetLineItemError {
  period: string[];
  percentageAmount: string[];
  amount: string[];
  closePeriod: string[];
}

export interface BudgetLineItemWarning {
  period: string[];
}

export interface BudgetLineItemInfo {
  period: string[];
}

const defaultViewBudgetErrors: BudgetLineItemError = {
  period: [],
  percentageAmount: [],
  amount: [],
  closePeriod: [],
};

const defaultViewBudgetWarnings: BudgetLineItemWarning = {
  period: [],
};

export const defaultViewBudgetInfos: BudgetLineItemInfo = {
  period: [],
};

const useViewBudgetTableErrors = (
  items: IBudgetPeriod[],
  type: 'Percentage' | 'Amount',
  glPeriods: GLPeriods,
  isReadOnly: boolean
) => {
  const errors = useMemo(
    () =>
      items.map((item) => {
        let error: BudgetLineItemError = { ...defaultViewBudgetErrors };
        let saveError: BudgetLineItemError = { ...defaultViewBudgetErrors };
        if (!item?.glPeriodId) {
          error.period = ['Please select an accounting period.'];
          saveError.period = ['Please assign an accounting period to all rows.'];
        }
        if (!item.percentageAmount) {
          error.percentageAmount = ['Please enter % Distribution value.'];
        }

        if (item.percentageAmount === 0 && type === 'Percentage') {
          error.percentageAmount = ['Please enter % Distribution value.'];
          saveError.percentageAmount = ['Please enter % Distribution value(s).'];
        }

        if (!item.amount) {
          error.amount = ['Please enter $ Distribution value.'];
        }
        if (item.amount === 0 && type === 'Amount') {
          error.amount = [
            `Please enter ${item.amount === 0 ? 'positive' : 'negative'} $ Distribution value.`,
          ];

          saveError.percentageAmount = [
            `Please enter ${item.amount === 0 ? 'positive' : 'negative'} $ Distribution value(s).`,
          ];
        }

        if (
          glPeriods.find((period) => period.glPeriodId === item.glPeriodId)?.isClosed &&
          !isReadOnly
        ) {
          error.period = [
            'PO includes a closed period. Please update the PO with only open periods.',
          ];
          saveError.period = [
            'PO includes a closed period. Please update the PO with only open periods.',
          ];
        }
        return { error, saveError };
      }, []),
    [glPeriods, isReadOnly, items, type]
  );

  const warnings = useMemo(
    () =>
      items.map((item) => {
        let warning: BudgetLineItemWarning = { ...defaultViewBudgetWarnings };
        const isEndingBalanceNegative = item.items.some(
          (lineItem) => lineItem.endingBalanceAmount < 0
        );
        if (isEndingBalanceNegative) {
          warning.period = ['A GL code for this period is over budget'];
        }
        return warning;
      }),
    [items]
  );

  const infos = useMemo(
    () =>
      items.map((item) => {
        let messages: BudgetLineItemInfo = { ...defaultViewBudgetInfos };

        return messages;
      }),
    [items]
  );

  return {
    errors: errors.map((err) => err.error),
    saveErrors: errors.map((err) => err.saveError),
    warnings,
    infos,
  };
};

export default useViewBudgetTableErrors;
